
import { language as lan_shipping } from "./shipping";
import { language as lan_stepNavConfig } from "./step-nav-config";
import { language as lan_payment } from "./payment";

let language = {
    ...lan_shipping,
    ...lan_stepNavConfig,
    ...lan_payment,
    // 结算页初始化失败
    A106B001: "Invalid page path",
    // 优惠码校验失败
    A106B002: "Invalid coupon code",
    A106B003: "Error Retrieving User Currency Preference Settings.",
    CHECKOUT_CREATE_SAMPLE_ORDER_ISSUE_TITLE: "Create Order Issue",
    CHECKOUT_CREATE_SAMPLE_ORDER_ERROR_TITLE: "Create Order Error",
    CHECKOUT_CREATE_SAMPLE_ORDER_ISSUE_CONTENT: "An error occurred while trying to create your order. Please try again. If the issue persists, contact our support team at {{supportmail}}.",
    CHECKOUT_CREATE_SAMPLE_ORDER_ISSUE_BY_ADDRESS_CONTENT: "The shipping address for this order is outside {{appName}}'s service coverage area. Please change the address to proceed this order. {{regions}}",
    CHECKOUT_CREATE_SAMPLE_ORDER_ISSUE_BY_CURRENCY_CONTENT: "Currency Type Changed. Please review your order information and proceed with placing your order again.",
    CHECKOUT_CREATE_SAMPLE_ORDER_MISSING_SHIPPING_ADDRESS_TITLE: "Missing Shipping Address",
    CHECKOUT_CREATE_SAMPLE_ORDER_MISSING_SHIPPING_ADDRESS_CONTENT: "Please ensure your shopping address is not empty.",
    CHECKOUT_CREATE_SAMPLE_ORDER_MISSING_BILLING_ADDRESS_TITLE: "Missing Billing Address",
    CHECKOUT_CREATE_SAMPLE_ORDER_MISSING_BILLING_ADDRESS_CONTENT: "Please ensure your billing address is not empty.",
    CHECKOUT_CREATE_SAMPLE_ORDER_COUPON_TITLE: "Coupon exceeds the maximum limit",
    CHECKOUT_CREATE_SAMPLE_ORDER_COUPON_CONTENT: "Only 1 coupon can be used for your order, please remove excess coupons.",
    // 步骤数据不完备
    CHECKOUT_STEP_INCOMPLETE_TITLE: "Step data check failure",
    CHECKOUT_STEP_INCOMPLETE_CONTENT: "The data in the current step is incomplete, and the next step cannot be skipped.",
    CHECKOUT_PAGE_INIT_ISSUE_TITLE: "Page Loading Issue",
    CHECKOUT_PAGE_INIT_ISSUE_CONTENT: "An issue occurred while loading this page. Please refresh the page and try again. If the problem persists, feel free to contact our support team at {{supportmail}}.",

    // 购物车项已结算
    CHECKOUT_ABSENCE_CART_ITEM_TITLE: "Anomaly with Shopping Cart Items",
    CHECKOUT_ABSENCE_CART_ITEM_CONTENT: "There are already settled items in the shopping cart. Please go to the shopping cart and select again.",
    CHECKOUT_CART_ITEM_ISSUE_TITLE: "Checkout Issue",
    CHECKOUT_CART_ITEM_ERROR_TITLE: "Checkout Error",
    CHECKOUT_CART_ITEM_ISSUE_CONTENT: "An error occurred while loading check out items. Please refresh the page and try again. If the problem persists, feel free to contact our support team at {{supportmail}}.",
    CHECKOUT_TOTAL_PRICE_ISSUE_TITLE: "Checkout Issue",
    CHECKOUT_TOTAL_PRICE_ERROR_TITLE: "Checkout Error",
    CHECKOUT_TOTAL_PRICE_ISSUE_CONTENT: "An issue occurred while loading check out total price. Please refresh the page and try again. If the problem persists, feel free to contact our support team at {{supportmail}}.",
    CHECKOUT_CURRENCY_CONFIG_MISSING_CONTENT:"There is an error with the {{appName}} currency setting. Please refresh the page and click \"{{updateCurrencyBtn}}\" to update {{appName}} display currency. If issues still persist, please contact {{serviceEmail}}.",
    CHECKOUT_CURRENCY_NONSUPPORT_CONTENT:"The currency you selected is not supported. Please click \"{{updateCurrencyBtn}}\" to update {{appName}} display currency. ",
    A106B3000601: "The current currency: {{currentCurrency}}, supported currency types on the {{appName}} platform: {{supportCurrencies}}",
    A106B300310: "The currency {{currentCurrency}} does not exist in the system."
}

export { language }